import { TableColumn, TableData } from '@billy/design-system'
import { Document } from '@react-pdf/renderer'
import { ReactElement } from 'react'

import { Currency } from '../../../../../../../../types/currency'
import { LocaleIdentifier } from '../../../../../../../../types/localeIdentifier'
import { SalesReportPdfStatistics } from '../../types/salesReportPdfStatistics'
import { SalesReportPdfGraphImage } from './elements/SalesReportPdfGraphImage'
import { SalesReportPdfHeader } from './elements/SalesReportPdfHeader'
import { SalesReportPdfPage } from './elements/SalesReportPdfPage'
import { SalesReportPdfStatisticsCard } from './elements/SalesReportPdfStatisticsCard'
import { SalesReportPdfTable } from './elements/SalesReportPdfTable'

interface SalesReportExportPdfDocumentProps<T extends TableData> {
  currency: Currency
  documentTitle: string
  endDate: string | undefined
  firstFiscalYearStart: string | undefined
  footerLabel: string
  graphImageSrc?: string
  locale: LocaleIdentifier
  organizationName: string | undefined
  startDate: string | undefined
  tableColumns: TableColumn<T>[]
  tableData: T[]
  totalSales: string
  statistics: SalesReportPdfStatistics
}

export const SalesReportExportPdfDocument = <T extends TableData>({
  currency,
  documentTitle,
  endDate,
  firstFiscalYearStart,
  footerLabel,
  graphImageSrc,
  locale,
  organizationName,
  startDate,
  statistics,
  tableColumns,
  tableData,
  totalSales,
}: SalesReportExportPdfDocumentProps<T>): ReactElement => {
  return (
    <Document>
      <SalesReportPdfPage>
        <SalesReportPdfHeader
          documentTitle={documentTitle}
          endDate={endDate}
          firstFiscalYearStart={firstFiscalYearStart}
          locale={locale}
          organizationName={organizationName}
          startDate={startDate}
        />
        <SalesReportPdfStatisticsCard statistics={statistics} />
        <SalesReportPdfGraphImage graphImageSrc={graphImageSrc} />
        <SalesReportPdfTable
          currency={currency}
          footerLabel={footerLabel}
          locale={locale}
          tableColumns={tableColumns}
          tableData={tableData}
          totalSales={totalSales}
        />
      </SalesReportPdfPage>
    </Document>
  )
}
